import { ADD_LOADER, REMOVE_LOADER } from '@/consts/store'

import Store from '@/stores/store'

export default {
  showLoader() {
    Store.commit(ADD_LOADER)
  },
  hideLoader() {
    Store.commit(REMOVE_LOADER)
  }
}
